import React from "react";
import { brandGradient } from "@/assets/branding";

const SIZE_PX = { xs: 18, sm: 24, md: 28, lg: 44, xl: 56, fab: 50 };

/**
 * KeviaAvatar — el logo oficial de Kéves, animado como presencia IA.
 *
 * state   : "idle" | "listening" | "thinking" | "responding"
 * size    : "xs" | "sm" | "md" | "lg" | "xl" | "fab" | number(px)
 * variant : "circle" (fondo oscuro standalone) | "raw" (sin fondo)
 * tier    : "local" | "plus" | null
 * mood    : "neutral" | "reflective" | "urgent" | "celebration" |
 *           "grief" | "pastoral-care" | "deep-focus" | null
 */
export const KeviaAvatar = React.memo(function KeviaAvatar({
  state   = "idle",
  size    = "md",
  variant = "circle",
  tier    = null,
  mood    = null,
  className = "",
}) {
  const px         = typeof size === "number" ? size : (SIZE_PX[size] ?? 28);
  const tierClass  = tier ? `kv-av--${tier}` : "";
  const moodClass  = mood && mood !== "neutral" ? `kv-av--mood-${mood}` : "";

  return (
    <div
      className={`kv-av kv-av--${state} ${tierClass} ${moodClass} ${variant === "circle" ? "kv-av--circle" : "kv-av--raw"} shrink-0 relative select-none ${className}`}
      style={{ width: px, height: px }}
      aria-hidden="true"
    >
      {variant === "circle" && (
        <>
          {/* Fondo oscuro con gradiente radial */}
          <span className="kv-av__bg absolute inset-0 rounded-full" />
          {/* Profundidad óptica — highlight superior + sombra inferior */}
          <span className="kv-av__inner absolute inset-0 rounded-full pointer-events-none" />
          {/* Halo ambiental — animado por estado y mood */}
          <span className="kv-av__halo absolute inset-0 rounded-full pointer-events-none" />
          {/* Ring borde con micro-breathing */}
          <span className="kv-av__ring absolute inset-0 rounded-full pointer-events-none" />
        </>
      )}

      {/* El logo de Kéves — asset original, solo animado */}
      <img
        src={brandGradient}
        alt=""
        draggable="false"
        className={`kv-av__img relative w-full h-full object-contain pointer-events-none${
          variant === "circle" ? " p-[13%]" : ""
        }`}
      />
    </div>
  );
});

export default KeviaAvatar;
